<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 512 512"
>
  <path
    d="M52.068 507.661H86.78v-381.83H52.068zM416.542 507.661h34.712v-381.83h-34.712z"
    fill="#a3aaaf"
  />
  <path
    d="M477.288 221.288H364.475c-4.79 0-8.678-3.888-8.678-8.678s3.888-8.678 8.678-8.678h112.814c4.799 0 8.678 3.888 8.678 8.678s-3.88 8.678-8.679 8.678M138.847 221.288H26.034c-4.79 0-8.678-3.888-8.678-8.678s3.888-8.678 8.678-8.678h112.814c4.79 0 8.678 3.888 8.678 8.678s-3.888 8.678-8.679 8.678"
    fill="#e0e0e0"
  />
  <path
    d="M138.847 229.966h225.628v-34.712H138.847z"
    fill="#ece8d8"
  />
  <path
    d="M182.237 360.136c-4.79 0-8.678-3.888-8.678-8.678V195.254c0-4.79 3.888-8.678 8.678-8.678s8.678 3.888 8.678 8.678v156.203c0 4.791-3.887 8.679-8.678 8.679"
    fill="#9e5a23"
  />
  <path
    d="M121.492 403.525h86.779v-52.067h-86.779z"
    fill="#e15649"
  />
  <path
    d="M208.271 403.525h86.78v-52.067h-86.78z"
    fill="#bc342e"
  />
  <path
    d="M164.881 455.593h86.78v-52.068h-86.78z"
    fill="#a52525"
  />
  <path
    d="M121.492 455.593h43.389v-52.068h-43.389z"
    fill="#bc342e"
  />
  <path
    d="M251.661 455.593h86.78v-52.068h-86.78z"
    fill="#e15649"
  />
  <path
    d="M338.441 455.593h43.39v-52.068h-43.39z"
    fill="#bc342e"
  />
  <path
    d="M121.492 507.661h86.779v-52.068h-86.779z"
    fill="#e15649"
  />
  <path
    d="M208.271 507.661h86.78v-52.068h-86.78z"
    fill="#bc342e"
  />
  <path
    d="M295.051 507.661h86.78v-52.068h-86.78zM295.051 403.525h86.78v-52.067h-86.78z"
    fill="#a52525"
  />
  <path
    d="M503.322 125.831H0L34.712 4.339H468.61z"
    fill="#9e5a23"
  />
  <path
    d="M477.288 256a8.676 8.676 0 0 1-8.678-8.678V212.61a8.676 8.676 0 0 1 8.678-8.678 8.676 8.676 0 0 1 8.678 8.678v34.712a8.676 8.676 0 0 1-8.678 8.678"
    fill="#e0e0e0"
  />
  <path
    d="M503.322 256h-26.034c-4.799 0-8.678-3.888-8.678-8.678s3.879-8.678 8.678-8.678h26.034c4.799 0 8.678 3.888 8.678 8.678S508.121 256 503.322 256"
    fill="#e0e0e0"
  />
  <path
    d="M216.949 238.644c-4.79 0-8.678-3.888-8.678-8.678v-34.712c0-4.79 3.888-8.678 8.678-8.678s8.678 3.888 8.678 8.678v34.712c0 4.79-3.888 8.678-8.678 8.678M251.661 238.644c-4.79 0-8.678-3.888-8.678-8.678v-34.712c0-4.79 3.888-8.678 8.678-8.678 4.79 0 8.678 3.888 8.678 8.678v34.712c0 4.79-3.888 8.678-8.678 8.678"
    fill="#9e5a23"
  />
</svg>
